import React, { useState } from 'react';
import Nav from '../Nav';
import HeaderJob from './HeaderJob';
import Search from './Search';
// ==== تم تعديل هذا السطر ====
import AvailableJobs from './AvailableJobs';
// ==== وتمت إضافة هذا السطر ====
import { useJobs } from '../../hooks/useJobs'; // استيراد الخطاف من مساره الصحيح
import Footer from '../Footer';

const Jobs = () => {
    const [searchTerm, setSearchTerm] = useState('');
    // استخدام الخطاف هنا لجلب العدد الإجمالي للوظائف
    const { jobsCount } = useJobs();

    return (
        <div>
            <Nav />
            <HeaderJob />
            {/* تمرير العدد الإجمالي للوظائف إلى مكون البحث */}
            <Search onSearch={setSearchTerm} jobsNumber={jobsCount} />
            <AvailableJobs searchTerm={searchTerm} />
            <Footer />
        </div>
    );
};

export default Jobs;